(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["isla-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('isla-carousel'))customElements.define('isla-carousel',class extends HTMLElement{
 connectedCallback(){if(this.bound)return;this.bound=true;this.index=0;this.slides=[...this.querySelectorAll('[data-slide]')];this.abort=new AbortController();this.addEventListener('click',event=>{const target=event.target.closest('button');if(!target)return;if(target.hasAttribute('data-next'))this.show(this.index+1);if(target.hasAttribute('data-prev'))this.show(this.index-1);if(target.hasAttribute('data-go'))this.show(Number(target.dataset.go));},{signal:this.abort.signal});document.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('[data-slide]');if(slide&&this.contains(slide))this.show(Number(slide.dataset.slide));},{signal:this.abort.signal});}
 disconnectedCallback(){this.abort?.abort();this.bound=false;}
 show(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;slide.inert=i!==this.index;slide.setAttribute('aria-hidden',String(i!==this.index));});this.querySelectorAll('[data-go]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.go)===this.index)));const current=this.querySelector('[data-current]');if(current)current.textContent=String(this.index+1).padStart(2,'0');}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
